import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { applyConsentReturn } from './lib/watchtower';
import './index.css';

// Consent returns as `?wt=usage` (a fragment is illegal in an OAuth
// redirect_uri); convert it to the SPA's hash route before React mounts.
applyConsentReturn();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
